/**
 * Browser helpers for SyncTask Manager Do Not Disturb (mute interruptive auto-open).
 *
 * Mute does not stop task tracking or badge updates — only panel auto-open.
 */

const STORAGE_KEY = "orderlink.taskNotificationsMuted";

/**
 * @return {boolean} Whether task notifications (auto-open) are muted.
 */
export function isTaskNotificationsMuted() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "true";
  } catch (error) {
    return false;
  }
}

/**
 * Persist the task notifications mute flag.
 *
 * @param {boolean} muted
 */
export function setTaskNotificationsMuted(muted) {
  try {
    window.localStorage.setItem(STORAGE_KEY, muted ? "true" : "false");
  } catch (error) {
    // Ignore storage failures (private mode, etc.).
  }
}
